export const config = {
  graphqlUrl:
    "https://dgrmdyvxek5zip6baoimfjn7ui0czfxt.lambda-url.us-west-2.on.aws/graphql",
};
